<p><b>{{ title }}</b></p>
<p>{{ message }}</p>
<div id="smr-confirmation-buttons">
    <button type="button" mat-button 
        (click)="mdDialogRef.close()">{{ 'DIALOG.NO' | translate }}</button>
    <button type="button" mat-raised-button 
        (click)="mdDialogRef.close(true)">{{ 'DIALOG.YES' | translate }}</button>
</div>
